import {
    MANAGE_GROUPS_DIALOG_INIT,
    MANAGE_GROUPS_DIALOG_LOADING_TRUE,
    MANAGE_GROUPS_DIALOG_LOADING_FALSE,
    MANAGE_GROUPS_DIALOG_IMPORT,
    IMPORT_GROUP_MEMBERS_REQUEST,
    MANAGE_GROUPS_DIALOG_SET_ROWS,
    MANAGE_GROUPS_DIALOG_SET_ROW_LOADING,
    MANAGE_GROUPS_DIALOG_CREATE_NEW_GROUP,
    MANAGE_GROUPS_DIALOG_IMPORT_SINGLE,
    MANAGE_GROUPS_DIALOG_IMPORT_REMOVE,
    MANAGE_GROUPS_GET_GROUPS_FOR_ENTITY_REQUEST,
} from './constants'

import config from '../../../../config'

export function manageGroupsDialogInit(entities) {
    return {
        type: MANAGE_GROUPS_DIALOG_INIT,
        data: {
            entities,
        },
    }
}

export function manageGroupsDialogLoadingTrue() {
    return {
        type: MANAGE_GROUPS_DIALOG_LOADING_TRUE,
    }
}

export function manageGroupsDialogLoadingFalse() {
    return {
        type: MANAGE_GROUPS_DIALOG_LOADING_FALSE,
    }
}

export function manageGroupsDialogSetRows(groups, isPresentInGroups) {
    return {
        type: MANAGE_GROUPS_DIALOG_SET_ROWS,
        data: {
            groups,
            isPresentInGroups,
        },
    }
}

export function manageGroupsDialogImport(groupId, entities, index, newGroup = false) {
    return {
        type: MANAGE_GROUPS_DIALOG_IMPORT,
        data: {
            groupId,
            entities,
            index,
            newGroup,
        },
    }
}

export function importGroupMembersRequest(members, groupId, country, index = 0) {
    return {
        type: IMPORT_GROUP_MEMBERS_REQUEST(country, index),
        payload: {
            ...config.api.groupStack.importGroupMembers,
            qs: {
                id: groupId,
            },
            body: {
                country,
                members,
            },
        },
    }
}

export function manageGroupsDialogSetRowLoading(index, value) {
    return {
        type: MANAGE_GROUPS_DIALOG_SET_ROW_LOADING,
        data: {
            index,
            value,
        },
    }
}

export function manageGroupsDialogCreateNewGroup(entities, dialog) {
    return {
        type: MANAGE_GROUPS_DIALOG_CREATE_NEW_GROUP,
        data: {
            entities,
            dialog,
        },
    }
}

export function manageGroupsDialogImportSingle(groupId, entities, index) {
    return {
        type: MANAGE_GROUPS_DIALOG_IMPORT_SINGLE,
        data: {
            groupId,
            entities,
            index,
        },
    }
}
export function manageGroupsDialogRemove(groupId, entities, index) {
    return {
        type: MANAGE_GROUPS_DIALOG_IMPORT_REMOVE,
        data: {
            groupId,
            entities,
            index,
        },
    }
}

export function manageGroupsGetGroupsForEntityRequest(entId) {
    return {
        type: MANAGE_GROUPS_GET_GROUPS_FOR_ENTITY_REQUEST,
        payload: {
            ...config.api.groupQuery.getGroupsForEntity,
            qs: {
                entId,
            },
        },
    }
}
